<template>
	<div id="app">
		<router-view />
    <renewPush />
	</div>
</template>

<script>
import renewPush from '@/components/renewPush/index.vue';
export default {
	name: 'App',
  components:{
    renewPush
  },
  data(){
    return {
      scale: 1
    }
  },
	methods: {
		appInit() {
			//从缓存中获取用户信息
			let LOGINUSER = JSON.parse(localStorage.getItem('LOGINUSER')) || null;
			if (LOGINUSER) {
				this.$store.commit('GETLOGINUSER', LOGINUSER);
			} else {
				this.$route.name != 'login' && this.$router.push('/login');
			}
		},
    // 计算缩放比例
    calculateScale(){
      const minWidth = 1366; // 最小宽度
      const minHeight = 768; // 最小高度
      const currentWidth = window.innerWidth;
      const currentHeight = window.innerHeight;

      const scaleX = currentWidth / minWidth;
      const scaleY = currentHeight / minHeight;

      // 设置最小缩放比例为0.5，防止屏幕太小导致内容难以辨认
      const newScale = Math.max(Math.min(scaleX, scaleY, 1), 0.5);
      this.scale = newScale;

      // 设置 body 的缩放
      document.body.style.transform = `scale(${newScale})`;
      document.body.style.transformOrigin = 'top left';
      document.body.style.width = `${100 / newScale}%`;
      document.body.style.height = `${100 / newScale}%`;
      document.body.style.position = 'absolute';
    }
	},
  mounted() {
    this.calculateScale();
    window.addEventListener('resize', this.calculateScale);

    // 添加 MutationObserver 来阻止 body 宽度变化
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const body = document.body;
          if (body.style.width === 'calc(100% - 10px)') {
            body.style.width = `${100 / this.scale}%`;
          }
        }
      });
    });

    // 开始观察 body 的样式变化
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style']
    });
  },
	created() {
		this.appInit();
	},
};
</script>

<style lang="scss">
@import '@/public/css/base.scss';
#app {
	height: 100%;
}
.el-dialog {
	display: flex;
	flex-direction: column;
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	/*height:600px;*/
	max-height: calc(100% - 30px);
	max-width: calc(100% - 30px);
}
.el-message-box__message p {
	word-break: break-all;
}
.el-popover {
	.el-button {
		border: unset;
	}
}
</style>
